module.exports = __webpack_public_path__ + "static/media/file_download_black_24dp.f5b909b9.svg";